export default __webpack_public_path__ + "static/media/DSCN2284.12c39360.JPG";